import {
  SEND_RECOVERY_PASSWORD_EMAIL_INIT,
  SEND_RECOVERY_PASSWORD_EMAIL_SUCCESS,
  SEND_RECOVERY_PASSWORD_EMAIL_ERROR,
  SHOW_MODAL_PASSWORD,
  HIDE_MODAL_PASSWORD,
  SHOW_NEW_PASSWORD_FORM,
  SUCCESS_PASSWORD_CHANGED, CLEAR_RESET_PASSWORD_DATA,
} from '../actions/forgot-password';

const initialState = {
  loading: false,
  data: {},
  error: null,
  modalVisibility: false,
  tokenPass: null,
  showNewPasswordForm: null,
  successPasswordChanged: false,
};

export default function resetPassword(state = initialState, action) {
  switch (action.type) {
    case SEND_RECOVERY_PASSWORD_EMAIL_INIT:
      return { ...state, loading: true, data: {}, error: null };
    case SEND_RECOVERY_PASSWORD_EMAIL_SUCCESS:
      return { ...state, loading: false, data: action.response, error: null };
    case SEND_RECOVERY_PASSWORD_EMAIL_ERROR:
      return { ...state, loading: false, data: {}, error: action.error };
    case SHOW_MODAL_PASSWORD:
      return { ...state, modalVisibility: true, tokenPass: action.token, showNewPasswordForm: false };
    case SHOW_NEW_PASSWORD_FORM:
      return { ...state, showNewPasswordForm: true };
    case HIDE_MODAL_PASSWORD:
      return { ...initialState };
    case SUCCESS_PASSWORD_CHANGED:
      return { ...state, successPasswordChanged: true };
    case CLEAR_RESET_PASSWORD_DATA:
      return { ...initialState };
    default:
      return state;
  }
}
